import * as GETTERS from '@/store/constants/getters.js';
import * as ROUTES from '@/constants/routes.js';
import { ATTENTION_TIME_FIELDS } from '@/constants/time.js';

export const getters = {
    [GETTERS.CURRENT_TIME](state) {
        return state.current;
    },
    [GETTERS.PREVIOUS_TIME](state) {
        return state.previous;
    },
    [GETTERS.LAST_ACTIVE](state) {
        return state.last_active;
    },
    [GETTERS.IS_INACTIVE](state) {
        return state.is_inactive;
    },
    [GETTERS.GET_TIME](state) {
        return (key) => state[key];
    },
    [GETTERS.GET_EVENT_HISTORY](state) {
        return state.event_history;
    },
    [GETTERS.GET_CURRENT_TIME_FIELD](state, getters) {
        const route = getters[GETTERS.CURRENT_ROUTE];

        switch (route) {
            case ROUTES.QUEUE:
                const currentQueueUuid = getters[GETTERS.CURRENT_QUEUE_UUID];
                const queue = getters[GETTERS.QUEUE_BY_UUID](currentQueueUuid);
                const batchIsEmpty = !queue || queue.content.length === 0;
                return batchIsEmpty ? ATTENTION_TIME_FIELDS.BATCH_AWAITING : ATTENTION_TIME_FIELDS[ROUTES.QUEUE];
            default:
                return ATTENTION_TIME_FIELDS[route] || '';
        }
    },
};
